import { XML_AddSingle } from "./XML_AddSingle.js";

export function XML_DrawLinkPPT(target, x, y, clipRect, drawElement, layer) {
  XML_AddSingle(target, "hyp", drawElement);
}
